__turbopack_context__.v({
  "formSearch": "styles-module__g55c9q__formSearch",
  "formSearchMobile": "styles-module__g55c9q__formSearchMobile",
});
